export default "/images/toggle-right.svg?adb79d3720b591e6c9482546042973e5";